import { render, staticRenderFns } from "./TradeImport.vue?vue&type=template&id=cc5f91a2&scoped=true"
import script from "./TradeImport.vue?vue&type=script&lang=js"
export * from "./TradeImport.vue?vue&type=script&lang=js"
import style0 from "./TradeImport.vue?vue&type=style&index=0&id=cc5f91a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5f91a2",
  null
  
)

export default component.exports